import { mapState, mapGetters } from 'vuex'
import { bootstrap } from 'vue-gtag'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

import './style.scss'
const whatInput = require('what-input')

export default {
  name: 'Layout',
  computed: {
    ...mapState({
      open: state => state.ui.menuOpen,
      options: state => state.data.data.options
    }),
    ...mapGetters(['getStringTranslation', 'lang'])
  },
  mounted () {
    // this.log(whatInput.ask())
  },
  watch: {
    '$route': function () {
      const urlLangDetected = this.$route.path.startsWith('/en') ? 'en' : 'de'
      this.$store.dispatch('loadData', urlLangDetected)
      this.$store.dispatch('changeLanguage', urlLangDetected)
    }
  },
  methods: {
    getTranslation (translationTitle) {
      return this.getStringTranslation(translationTitle)
    },
    cookieStatus(e) {
			// console.log('cookieStatus', e)
			if (e === 'decline') {
				// console.log('cookieStatus declined')
			}
			if (e === 'accept') {
				// console.log('cookieStatus accepted')
				this.bootstrapGtag()
			}
		},
		cookieClickedAccept(e) {
			// console.log('cookieClickedAccept', e)
			this.bootstrapGtag()
		},
		cookieClickedDecline(e) {
			// console.log('cookieClickedDecline', e)
		},
		bootstrapGtag() {
			bootstrap().then((gtag) => {
				// console.log('bootstrapped', gtag)
			})
		}
  },
  render (h) {
    const { options, lang } = this
    return (
      <div class='Layout'
        hidden={this.open ? 'hidden' : null}
      >
        <VueCookieAcceptDecline
          ref='cookiePanel'
          elementId='cookiePanel'
          class='VueCookieAcceptDecline__bar'
          debug={false}
          position='bottom'
          type='bar'
          disableDecline={false}
          transitionName='"slideFromBottom"'
          onStatus={this.cookieStatus}
          onClicked-accept={this.cookieClickedAccept}
          onClicked-decline={this.cookieClickedDecline}
        >
          <div slot='message' domPropsInnerHTML={ options && options.gdpr_cookie_text ? options.gdpr_cookie_text : ''} />
          <div slot='declineContent'>
            {lang === 'en' ? 'Decline' : 'Ablehnen'}
          </div>
          <div slot='acceptContent'>
              {this.getTranslation('accept')}
          </div>
        </VueCookieAcceptDecline>

        {this.$slots.default}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Layout/index.js